import type { FeatureId } from './featuresRegistry';
import type { IconName } from '@/design-system/icons/Icon';

export type PaletteEntry = {
  id: string;
  label: string;
  icon: IconName;
  route: string;
  feature?: FeatureId;
  group: string;
};

export const PALETTE_ENTRIES: PaletteEntry[] = [
  { id: 'getLaudo', label: 'Como ter acesso', icon: 'shield', route: '/get-laudo', group: 'Principal' },
  { id: 'dashboard', label: 'Início', icon: 'home', route: '/dashboard', group: 'Principal' },
  { id: 'feed', label: 'Feed', icon: 'activity', route: '/feed', feature: 'feed', group: 'Principal' },
  { id: 'communities', label: 'Comunidades', icon: 'users', route: '/communities', feature: 'communities', group: 'Principal' },
  { id: 'messages', label: 'Mensagens', icon: 'chat', route: '/messages', feature: 'messages', group: 'Principal' },
  { id: 'notifications', label: 'Notificações', icon: 'inbox', route: '/notifications', feature: 'notifications', group: 'Principal' },
  { id: 'reels', label: 'Reels & lives', icon: 'eye', route: '/reels', feature: 'reels', group: 'Principal' },

  { id: 'explore', label: 'Explorar', icon: 'grid', route: '/explore', feature: 'explore', group: 'Descobrir' },
  { id: 'search', label: 'Busca', icon: 'search', route: '/search', group: 'Descobrir' },
  { id: 'strains', label: 'Strains', icon: 'leaf', route: '/strains', feature: 'strains', group: 'Descobrir' },
  { id: 'effects', label: 'Efeitos', icon: 'activity', route: '/effects', group: 'Descobrir' },
  { id: 'associations', label: 'Associações', icon: 'building', route: '/associations', feature: 'associations', group: 'Descobrir' },
  { id: 'marketplace', label: 'Marketplace', icon: 'bag', route: '/marketplace', feature: 'marketplace', group: 'Descobrir' },

  { id: 'diary', label: 'Diário', icon: 'doc', route: '/diary', group: 'Ferramentas' },
  { id: 'meds', label: 'Medicamentos', icon: 'pill', route: '/meds', group: 'Ferramentas' },
  { id: 'donations', label: 'Fundo solidário', icon: 'heart', route: '/donations', feature: 'donations', group: 'Ferramentas' },
  { id: 'account', label: 'Minha conta', icon: 'user', route: '/account', group: 'Ferramentas' },
  { id: 'login', label: 'Entrar', icon: 'key', route: '/auth/login', group: 'Ferramentas' },
  { id: 'waitlist', label: 'Lista de espera', icon: 'inbox', route: '/waitlist', group: 'Ferramentas' },
  { id: 'legal', label: 'Termos & legal', icon: 'doc', route: '/legal', group: 'Ferramentas' },

  { id: 'panel', label: 'Painel da associação', icon: 'home', route: '/panel', group: 'Gestão' },
  { id: 'team', label: 'Equipe', icon: 'users', route: '/manage/team', group: 'Gestão' },
  { id: 'reviewsAdmin', label: 'Avaliações', icon: 'star', route: '/manage/reviews', group: 'Gestão' },
  { id: 'sales', label: 'Vendas', icon: 'money', route: '/manage/sales', group: 'Gestão' },
  { id: 'assocDocs', label: 'Documentos', icon: 'doc', route: '/manage/docs', group: 'Gestão' },
  { id: 'publishProduct', label: 'Publicar produto', icon: 'bag', route: '/marketplace/publish', group: 'Gestão' },
  { id: 'claim', label: 'Verificação', icon: 'shield', route: '/claim', group: 'Gestão' },
  { id: 'admin', label: 'Moderação', icon: 'flag', route: '/admin', group: 'Gestão' },
  { id: 'complaints', label: 'Denúncias', icon: 'shield', route: '/admin/complaints', group: 'Gestão' },
  { id: 'features', label: 'Recursos & módulos', icon: 'toggle', route: '/admin/features', group: 'Gestão' },
];
